module.exports = __webpack_public_path__ + "static/media/E33.77c2bd5c.jpg";